(function () {
  'use strict';

  function initSection(section) {
    if (!section || section.dataset.collectionTabsInit === 'true') return;
    section.dataset.collectionTabsInit = 'true';

    var tabs = section.querySelectorAll('.oddit-section-collection-tabs__tab');
    if (!tabs.length) return;

    var panels = section.querySelectorAll('.oddit-section-collection-tabs__panel');
    var ctaLink = section.querySelector('[data-cta-link]');
    var ctaUsesActive = section.dataset.ctaUsesActive === 'true';
    var ctaFallback = ctaLink ? (ctaLink.getAttribute('data-cta-fallback') || ctaLink.getAttribute('href')) : null;

    function activateTab(tab) {
      var index = tab.getAttribute('data-tab-index');
      if (index === null) return;
      var idx = Number(index);

      for (var i = 0; i < tabs.length; i++) {
        var t = tabs[i];
        var isActive = t === tab;
        t.classList.toggle('oddit-section-collection-tabs__tab--active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
      }

      for (var p = 0; p < panels.length; p++) {
        if (p === idx) {
          panels[p].removeAttribute('hidden');
        } else {
          panels[p].setAttribute('hidden', '');
        }
      }

      if (ctaLink && ctaUsesActive) {
        var collectionUrl = tab.getAttribute('data-collection-url');
        if (collectionUrl) {
          ctaLink.setAttribute('href', collectionUrl);
        } else if (ctaFallback) {
          ctaLink.setAttribute('href', ctaFallback);
        }
      }

      section.dispatchEvent(
        new CustomEvent('collection-tabs:change', {
          detail: { index: idx, tab: tab },
          bubbles: true
        })
      );
    }

    function handleClick(e) {
      var tab = e.currentTarget;
      activateTab(tab);
    }

    function handleKeydown(e) {
      var key = e.key;
      var currentIndex = -1;
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i] === e.currentTarget) {
          currentIndex = i;
          break;
        }
      }
      if (currentIndex < 0) return;

      var nextIndex = -1;
      if (key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (key === 'Home') {
        nextIndex = 0;
      } else if (key === 'End') {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex >= 0) {
        e.preventDefault();
        var next = tabs[nextIndex];
        activateTab(next);
        next.focus();
      }
    }

    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', handleClick);
      tabs[i].addEventListener('keydown', handleKeydown);
    }

    initSwatches(section);
  }

  function initSwatches(section) {
    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('.oddit-section-main-collection__variant-thumb');
      if (!thumb || !section.contains(thumb)) return;
      var group = thumb.closest('.oddit-section-main-collection__variant-thumbs');
      if (!group) return;
      e.preventDefault();
      e.stopPropagation();

      group.querySelectorAll('.oddit-section-main-collection__variant-thumb--selected').forEach(function (t) {
        t.classList.remove('oddit-section-main-collection__variant-thumb--selected');
      });
      thumb.classList.add('oddit-section-main-collection__variant-thumb--selected');

      var card = thumb.closest('.oddit-section-main-collection__product');
      if (!card) return;

      var swatchImage = thumb.getAttribute('data-swatch-image');
      if (swatchImage) {
        var img = card.querySelector('.oddit-section-main-collection__product-image');
        if (img) {
          img.src = swatchImage;
          var swatchSrcset = thumb.getAttribute('data-swatch-srcset');
          if (swatchSrcset) img.srcset = swatchSrcset;
        }
      }
    });
  }

  var sections = document.querySelectorAll('.oddit-section-collection-tabs');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.oddit-section-collection-tabs');
    if (section) initSection(section);
  });
})();
